module.exports = __webpack_public_path__ + "media/images/lb/201-899fed080472570e8c620646d1a9bd00.svg";